import React from 'react'
import PropTypes from 'prop-types'
import { bindAll, isEmpty, partial, get } from 'lodash-es'
import classnames from 'classnames'

/* Relative imports to comply with Headless Webpack config */
import IconComponent from '../IconComponent/IconComponent'
import TooltipComponent from '../TooltipComponent/TooltipComponent'
import ConditionWrapComponent from '../ConditionWrapComponent/ConditionWrapComponent'

import './ButtonComponent.scss'

const getHoverWrapper = (hoverIconConfig, children) => {
  const width = get(hoverIconConfig, 'size[0]')
  const height = get(hoverIconConfig, 'size[1]')

  return (
    <div className="icons-wrapper" style={{ width, height }}>
      {children}
      <IconComponent {...hoverIconConfig} />
    </div>
  )
}

class Button extends React.Component {
  constructor(props) {
    super(props)

    bindAll(this, 'onClick')
  }

  onClick(e) {
    const { disabled, onClick } = this.props

    if (!disabled) {
      onClick(e)
    } else {
      e.preventDefault()
    }
  }

  renderContent() {
    const { iconConfig, hoverIconConfig, children } = this.props
    let content = children

    if (!isEmpty(iconConfig)) {
      content = (
        <>
          <ConditionWrapComponent
            condition={!isEmpty(hoverIconConfig)}
            wrap={partial(getHoverWrapper, hoverIconConfig)}
          >
            <IconComponent {...iconConfig} />
          </ConditionWrapComponent>
          <div>{children}</div>
        </>
      )
    }

    return <div className="button-flex">{content}</div>
  }

  render() {
    const {
      className,
      size,
      color,
      outlined,
      disabled,
      type,
      tooltip,
      round,
      style,
      tooltipOptions,
      ariaLabel,
    } = this.props

    const commonButtonProps = {
      onClick: this.onClick,
      className: classnames(
        'button-component',
        `button-${size}`,
        `button-${color}`,
        { 'button-outlined': outlined },
        { 'button-disabled': disabled },
        { 'button-round': round },
        { [className]: className }
      ),
      style,
      tabIndex: disabled ? -1 : 0,
    }

    /* oxlint-disable react/button-has-type */
    let result = null
    switch (type) {
      case 'submit':
      case 'button':
        result = (
          <button
            type={type}
            {...commonButtonProps}
            {...(ariaLabel && { 'aria-label': ariaLabel })}
          >
            {this.renderContent()}
          </button>
        )
        break
      default:
        return null
    }

    if (tooltip) {
      return (
        <TooltipComponent
          title={tooltip}
          mouseEnterDelay={1}
          overlayStyle={{ width: 215 }}
          {...(tooltipOptions || {})}
        >
          {result}
        </TooltipComponent>
      )
    }

    return result
  }
}

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['submit', 'button']),
  size: PropTypes.oneOf(['small', 'normal', 'large']),
  color: PropTypes.oneOf([
    'green',
    'mist-green',
    'grey',
    'red',
    'yellow',
    'purple',
    'pink',
    'transparent',
    'themed',
  ]),
  round: PropTypes.bool,
  outlined: PropTypes.bool,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  routeName: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  iconConfig: PropTypes.object,
  hoverIconConfig: PropTypes.object,
  tooltip: PropTypes.string,
  tooltipOptions: PropTypes.object,
  style: PropTypes.object,
  ariaLabel: PropTypes.string,
}

Button.defaultProps = {
  className: '',
  type: 'button',
  size: 'normal',
  color: 'green',
  outlined: false,
  disabled: false,
  href: '/',
  onClick: () => {},
}

export default Button
